// extracted by mini-css-extract-plugin
export default {"price":"H7-z","onSale":"I7-z","msrpLabelPrice":"J7-z","msrpLabel":"K7-z","originalPrice":"L7-z","percentOff":"M7-z"};